import { useMutation, useQuery } from 'react-query'
import { useGqlClient } from '@aposphaere/core-kit'
import { QueryOptions } from 'react-query'
import { requestPasswordReset } from '@aposphaere/core-kit'

type Variables = {
  email: string
}

type ValidateResetParams = {
  email: string
  token: string
}

type VariablesReset = {
  email: string
  token: string
  password: string
}

export const useRequestPasswordResetMutation = (options?: QueryOptions<unknown>) => {
  const gqlClient = useGqlClient()

  return useMutation(async (variables: Variables) => await gqlClient.request<{ requestPasswordReset: boolean }>(requestPasswordReset, variables), {
    ...options,
  })
}

export const useValidateResetTokenQuery = ({ email, token }: ValidateResetParams) => {
  const gqlClient = useGqlClient()

  return useQuery(
    ['validate-reset', email, token],
    async () => {
      const res = await gqlClient.request(
        `
      query ValidatePasswordResetToken($email: String!, $token: String!) {
        validatePasswordResetToken(email: $email, token: $token)
      }
      `,
        { email, token },
      )

      return res.validatePasswordResetToken
    },
    {
      enabled: !!email && !!token,
    },
  )
}

export const useResetPasswordMutation = () => {
  const gqlClient = useGqlClient()

  return useMutation(async (variables: VariablesReset) => {
    const res = await gqlClient.request<{
      resetPassword: boolean
    }>(
      `
      mutation ResetPassword($email: String!, $token: String!, $password: String!) {
        resetPassword(email: $email, token: $token, password: $password)
      }
      `,
      variables,
    )

    return res.resetPassword
  })
}